import React, {Component} from 'react';
import './share.scss';

import API from './../../config/api';

import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';

@connect(
    state => ({admin: state.admin}),
    {refresh_admin}
)

class Share extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {
        window.location.href = 'https://android.myapp.com/myapp/detail.htm?apkName=com.foundao.bjnews';
        // $('html,body,#root').css({
        //     height: '100%'
        // })\
        // this.ymstatistics()
    }

    componentDidMount() {
        this.initWx({});
    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {

        return (
            <div className="share-box">
                <div className="bottom-box">
                    <div className="text-box">好新闻 无止境</div>
                    <div className="open-app-btn" onClick={this.openApp}>打开新京报App</div>
                </div>
            </div>
        );
    }

    ymstatistics() {
        setTimeout(() => {
            if (window._czc) {
                let location = window.location
                let contentUrl = location.pathname + location.hash
                let refererUrl = '/'
                window._czc.push(['_trackPageview', contentUrl], refererUrl)
            } else {
                console.log('_czc null')
            }
        }, 2000)
    }

    openApp() {
        // var nativeUrl = {
        //     ios: 'com.foundaoBeijingNewsApp://',
        //     // android: 'com.cctv.ugc://activity:/newsDetail?videoId='
        // };
        // var downloadUrl = {
        //     ios: 'http://itunes.apple.com/cn/app/id1433487171?mt=8',
        //     // android: 'https://www.newscctv.net/apkdownload/index.html'
        // };
        // if(Tool.isIOS()){
        //     if(Tool.isWeiXin()){
        //         //提示在浏览器打开
        //     }else {
        //         // window.location.href = nativeUrl.ios;
        //         setTimeout(function () {
        //             window.location.href = downloadUrl.ios ;
        //         }, 2000);
        //     }
        // }
        window.location.href = 'https://android.myapp.com/myapp/detail.htm?apkName=com.foundao.bjnews';
    }

    initWx(obj) {
        //分享
        var wxconfig = new window.WxConfig();
        console.log(window.location.href);
        wxconfig.init({
            appid: API.appid,
            url: window.location.href,
            title: obj.title || API.share_title,
            desc: obj.desc || API.share_des,
            link: window.location.href,
            imgUrl: API.share_img,
            successCallback: this.statistics.bind(this, true)
        });
    }
}

export default Share;


// WEBPACK FOOTER //
// ./src/pages/Share/share.js